<template>
    <div>
        <div class="userDatatable userDatatable--ticket userDatatable--ticket--2 mt-1 mb-3">
            <div class="table-responsive">
                <table class="table mb-0 table-borderless">
                    <thead>
                        <tr class="userDatatable-header">
                            <th>
                                <span class="userDatatable-title">ID</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Nama Produk</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Harga</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Tipe</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Stok</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Status</span>
                            </th>
                            <th>
                                <span class="userDatatable-title">Actions</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in products" :key="product.id">
                            <td>{{ product.id }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <img 
                                        v-if="product.image_url" 
                                        :src="product.image_url" 
                                        alt="Product" 
                                        style="width: 50px; height: 50px; border-radius: 8px; margin-right: 10px; object-fit: cover;"
                                    />
                                    <div>
                                        <div><strong>{{ product.name }}</strong></div>
                                        <small class="text-muted">{{ product.description ? (product.description.substring(0, 50) + '...') : '-' }}</small>
                                    </div>
                                </div>
                            </td>
                            <td><strong>Rp {{ formatRupiah(product.price) }}</strong></td>
                            <td>
                                <span :class="product.type === 'digital' ? 'badge badge-info' : 'badge badge-secondary'">
                                    <i :class="product.type === 'digital' ? 'fas fa-download' : 'fas fa-box'"></i>
                                    {{ product.type === 'digital' ? 'Digital' : 'Fisik' }}
                                </span>
                            </td>
                            <td>
                                <span v-if="product.stock !== null" class="badge badge-primary">{{ product.stock }}</span>
                                <span v-else class="badge badge-success">Unlimited</span>
                            </td>
                            <td>
                                <span :class="product.status === 'active' ? 'badge badge-success' : 'badge badge-danger'">
                                    {{ product.status }}
                                </span>
                            </td>
                            <td>
                                <div class="action-btn">
                                    <button @click="$emit('edit-product', product.id)" class="btn btn-sm btn-primary" title="Edit">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    <button @click="$emit('delete-product', product.id)" class="btn btn-sm btn-danger" title="Hapus">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="products.length === 0">
                            <td colspan="7" class="text-center py-4">
                                <i class="fas fa-box fa-2x text-muted mb-2"></i>
                                <p class="text-muted">Belum ada produk. Klik tombol "Tambah Produk" untuk menambahkan produk pertama.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductTable',
        props: {
            shopId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                products: []
            };
        },
        mounted() {
            this.loadProducts();
            this.$root.$on('refresh-product-table', this.loadProducts);
        },
        beforeDestroy() {
            this.$root.$off('refresh-product-table', this.loadProducts);
        },
        methods: {
            async loadProducts() {
                try {
                    const response = await this.$store.dispatch('shop_product/shop_product_list', {
                        shopId: this.shopId,
                        params: {
                            limit: 100,
                            page: 1
                        }
                    });
                    this.products = response.data.data.products || [];
                } catch (error) {
                    console.error('Error loading products:', error);
                    this.products = [];
                }
            },
            formatRupiah(value) {
                return new Intl.NumberFormat('id-ID').format(value);
            }
        }
    };
</script>

